module.exports = __webpack_public_path__ + "static/img/step3.48e28ee8.png";